import { TagProps } from '@approvalmax/ui/src/components';
import { TransactionStatus } from 'shared/data/wallets/v1';

import { messages } from './TransactionStatusTag.messages';

export const tagConfig: Record<TransactionStatus, Pick<TagProps, 'color' | 'outline' | 'children'>> = {
    [TransactionStatus.completed]: {
        children: messages.completed,
        color: 'green100',
        outline: false,
    },
    [TransactionStatus.pending]: {
        children: messages.pending,
        color: 'green100',
        outline: true,
    },
    [TransactionStatus.failed]: {
        children: messages.failed,
        color: 'red100',
        outline: false,
    },
    [TransactionStatus.cancelled]: {
        children: messages.cancelled,
        color: 'red100',
        outline: true,
    },
    [TransactionStatus.created]: {
        children: messages.pending,
        color: 'green100',
        outline: true,
    },
};
